import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=905ebe5c&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=js&"
export * from "./Books.vue?vue&type=script&lang=js&"
import style0 from "./Books.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Books.vue?vue&type=style&index=1&id=905ebe5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905ebe5c",
  null
  
)

export default component.exports